module.exports = __webpack_public_path__ + "img/collection-weddingRingsCheap.c28f7b4.webp";